import AxiosClient from '../../../functional/Axios/AxiosClient';

export function faqGetAll(role) {
  return AxiosClient.get(`/faq/${role}`)
    .then((data) => data)
    .catch((error) => error);
}
